export const environment = {
    production: true,
    loggerConfiguration: {
        trace: false,
        debug: false,
        info: true,
        warn: true,
        error: true,
        fatal: true,
    }
};
